import { isTopWindowAccessible } from './isTopWindowAccessible.js';
const getTopWindow = () => (isTopWindowAccessible() ? window.top : window);
export { getTopWindow };
